import { isNaN, isNil } from 'lodash';
import { KPI_GREEN, KPI_RED, KPI_YELLOW } from '../../../../core/chart/colors';

export const formatValueByIndicator = (indicator, value) => {
  if (isNil(value) || isNaN(value)) {
    return 'N/A';
  }

  const indicatorsFormattedAsAbsolute = [
    'UNIT_ITEM_EXECUTION_REPEAT_RATE',
    'UNIT_ITEM_EXECUTION_SPEECH_RATE',
    'UNIT_EXECUTION_ERROR_RATE',
    'MASTERY_TEST_ITEM_EXECUTION_REPEAT_RATE',
    'MASTERY_TEST_ITEM_EXECUTION_SPEECH_RATE',
    'MASTERY_TEST_EXECUTION_ERROR_RATE',
  ];
  const indicatorsFormattedAsPercent = [
    'UNIT_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE',
    'MASTERY_TEST_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE',
  ];

  if (indicatorsFormattedAsAbsolute.some((i) => i === indicator)) {
    return value;
  } else if (indicatorsFormattedAsPercent.some((i) => i === indicator)) {
    return `${value > 0 ? '+' : ''}${value}%`;
  }
};

export const formatIndicator = (indicator) =>
  ({
    UNIT_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE: 'Failures over attempts',
    UNIT_ITEM_EXECUTION_REPEAT_RATE: 'Audio listening difficulty',
    UNIT_ITEM_EXECUTION_SPEECH_RATE: 'Speech recognition difficulty',
    UNIT_EXECUTION_ERROR_RATE: 'Error report',
    MASTERY_TEST_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE: 'Failures over attempts',
    MASTERY_TEST_ITEM_EXECUTION_REPEAT_RATE: 'Audio listening difficulty',
    MASTERY_TEST_ITEM_EXECUTION_SPEECH_RATE: 'Speech recognition difficulty',
    MASTERY_TEST_EXECUTION_ERROR_RATE: 'Error report',
  }[indicator]);

export const getColorByIndicatorAndValue = (indicator, value) => {
  return {
    UNIT_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE: (value) =>
      value <= 5 || value > 35
        ? KPI_RED
        : (value > 5 && value <= 10) || (value > 25 && value <= 35)
        ? KPI_YELLOW
        : KPI_GREEN,
    UNIT_ITEM_EXECUTION_REPEAT_RATE: (value) => (value <= 2 ? KPI_GREEN : value > 3 ? KPI_RED : KPI_YELLOW),
    UNIT_ITEM_EXECUTION_SPEECH_RATE: (value) => (value <= 2 ? KPI_GREEN : value > 3 ? KPI_RED : KPI_YELLOW),
    UNIT_EXECUTION_ERROR_RATE: (value) => (value <= 1 ? KPI_GREEN : value > 2 ? KPI_RED : KPI_YELLOW),
    MASTERY_TEST_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE: (value) =>
      value <= 5 || value > 35
        ? KPI_RED
        : (value > 5 && value <= 10) || (value > 25 && value <= 35)
        ? KPI_YELLOW
        : KPI_GREEN,
    MASTERY_TEST_ITEM_EXECUTION_REPEAT_RATE: (value) => (value <= 2 ? KPI_GREEN : value > 3 ? KPI_RED : KPI_YELLOW),
    MASTERY_TEST_ITEM_EXECUTION_SPEECH_RATE: (value) => (value <= 2 ? KPI_GREEN : value > 3 ? KPI_RED : KPI_YELLOW),
    MASTERY_TEST_EXECUTION_ERROR_RATE: (value) => (value <= 1 ? KPI_GREEN : value > 2 ? KPI_RED : KPI_YELLOW),
  }[indicator](value);
};

export const getGroupLabel = (group) => ({ 1: 'Default', 2: 'First Review', 3: 'Second Review' }[group]);
